import React from 'react';

import TabsHeader from './TabsHeader';
import TabsContainer from './TabsContainer';

const emptyFunction = () => {};

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabId: this.props.selectedTabId || 0,
    };
    this.headers = this.props.items?.map(item => {
      return {
        component: item.header,
        style: item.headerStyle,
      };
    });

    this.onTabsClick = this.props.items?.map(item => {
      return item.onClick || emptyFunction;
    });

    this.content = this.props.items?.map(item => {
      return item.content && (
          <React.Fragment key={`tabContent_${item.header}`}>
            {item.content}
          </React.Fragment>
      );
    });
  }

  static defaultProps = {
    onClick: () => {},
  };

  // static propTypes = {
  //   onClick: PropTypes.func,
  //   items: PropTypes.arrayOf(
  //     PropTypes.shape({
  //       header: PropTypes.string,
  //       content: PropTypes.element,
  //     }),
  //   ).isRequired,
  // };

  render() {
    return (
      <div className={`tabs tabs--sections ${this.props.className ? this.props.className : ''}`}>
        <TabsHeader
          items={this.headers}
          selectedTabId={this.state.selectedTabId}
          onItemClick={this.onTabsClick}
          onClick={selectedTabId => {
            this.setState({ selectedTabId });
          }}
        />

        <TabsContainer activeTab={this.state.selectedTabId}>
          {this.content}
        </TabsContainer>
      </div>
    );
  }
}

export default Tabs;
